/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetAssetTypesForSubsystemRequestDto
 */
export interface SetAssetTypesForSubsystemRequestDto {
    /**
     * ID of the subsystem
     * @type {string}
     * @memberof SetAssetTypesForSubsystemRequestDto
     */
    subsystemId: string;
    /**
     * Array of asset type IDs to associate with the subsystem
     * @type {Array<string>}
     * @memberof SetAssetTypesForSubsystemRequestDto
     */
    assetTypeIds: Array<string>;
}

/**
 * Check if a given object implements the SetAssetTypesForSubsystemRequestDto interface.
 */
export function instanceOfSetAssetTypesForSubsystemRequestDto(value: object): value is SetAssetTypesForSubsystemRequestDto {
    if (!('subsystemId' in value) || value['subsystemId'] === undefined) return false;
    if (!('assetTypeIds' in value) || value['assetTypeIds'] === undefined) return false;
    return true;
}

export function SetAssetTypesForSubsystemRequestDtoFromJSON(json: any): SetAssetTypesForSubsystemRequestDto {
    return SetAssetTypesForSubsystemRequestDtoFromJSONTyped(json, false);
}

export function SetAssetTypesForSubsystemRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetAssetTypesForSubsystemRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsystemId': json['subsystemId'],
        'assetTypeIds': json['assetTypeIds'],
    };
}

export function SetAssetTypesForSubsystemRequestDtoToJSON(json: any): SetAssetTypesForSubsystemRequestDto {
    return SetAssetTypesForSubsystemRequestDtoToJSONTyped(json, false);
}

export function SetAssetTypesForSubsystemRequestDtoToJSONTyped(value?: SetAssetTypesForSubsystemRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsystemId': value['subsystemId'],
        'assetTypeIds': value['assetTypeIds'],
    };
}

